import React, { useContext, useEffect, useRef } from 'react'
import './Nav.sass'
import Hamburger from 'react-hamburger-menu'
import Media from 'react-media'
import { withRouter } from 'react-router-dom'
import Logo from '../../ui/Logo/Logo'
import SiteNavLink from './SiteNavLink'
import { usePopUp } from '../../hooks/usePopUp'
import useScrollPosition from '../../hooks/useScrollPosition'
import CallUsBar from './CallUsBar'
import { AuthContext } from '../../App'

function Nav({ user, ...router }) {
  const hamRef = useRef()
  const navRef = useRef()
  const [menuIsOpen, setMenuIsOpen] = usePopUp(hamRef, navRef)
  const pos = useScrollPosition()
  const { setShowContactUs } = useContext(AuthContext)

  useEffect(() => {
    setMenuIsOpen(false)
  }, [router.location.pathname, router.location.hash])

  return (
    <nav
      id="nav"
      className={[
        'Site-Nav',
        ...(pos > 0 ? ['Site-Nav_theme_shadow'] : []),
      ].join(' ')}
    >
      <Media
        query="(max-width: 1200px)"
        render={() => (
          <span ref={hamRef}>
            <Hamburger
              isOpen={menuIsOpen}
              width={24}
              height={16}
              strokeWidth={2}
              className="Site-Hamburger-Container"
              color="#000000"
              borderRadius={2}
              animationDuration={0.2}
            />
          </span>
        )}
      />
      <Logo theme="accent" navLink path="/" />
      <div
        ref={navRef}
        className="Site-Nav-Menu"
        style={menuIsOpen ? { display: 'grid' } : {}}
      >
        <SiteNavLink title="Пекарня" path="/bakery" />
        <SiteNavLink title="Реализация соли и муки" path="/salt-and-flour" />
        <SiteNavLink title="Ж/Д логистика" path="/logistics-service" />
        <SiteNavLink title="Складское хранение" path="/warehouse-service" />
        <SiteNavLink title="О компании" path="/#about" />
        <SiteNavLink
          title="Вакансии"
          type="button"
          onClick={() => setShowContactUs(true)}
        />
        <SiteNavLink title="Контакты" path="/#contacts" />
      </div>
      <CallUsBar />
    </nav>
  )
}

// const mapStateToProps = (state) => ({ user: state.auth.user })

export default withRouter(Nav)
